export default "__VITE_ASSET__pyKSlB4D__"